import ProductEdit from '../components/Partners/PartnerEdit'; // Assuming you have this component
import { t } from '../i18n';

export default function ProductEditPage({ handleEditPartner }) {
  return (
    <>
      <h2 className="text-2xl font-semibold mb-4 text-blue-600">{t('Уреди партнер')}</h2>
      <ProductEdit onAdd={handleEditPartner} />
    </>
  );
}
